import { findDeploymentEnvFromUrl } from '@zooplus/commons-lang';

const CURRENT_ENVIRONMENT = findDeploymentEnvFromUrl();

export { CURRENT_ENVIRONMENT };
//# sourceMappingURL=environment-utils.js.map
